enum ImageTypeModel {
    Desktop = 'Desktop',
    Mobile = 'Mobile',
    Thumbnail = 'Thumbnail',
}

export default ImageTypeModel;
